import {resizeImage} from 'src/shared/utils/imageResize';

export {resizeImage};

export const getFileExtension = (filename: string): string => {
  return filename.substring(filename.lastIndexOf('.'));
};

const mimeTypeMapping = {
  '.cex': 'text/xml',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.heic': 'image/heic',
  '.heif': 'image/heif',
  '.webp': 'image/webp',
} as any;

export const validateFile = (file: File): File => {
  if (!file.type) {
    const extension = getFileExtension(file.name);
    const type = mimeTypeMapping[extension];

    if (!type) {
      throw 'Invalid file contents. Unable to process file.';
    }

    return new File([file], file.name, {type: type});
  }

  return file;
};

export const isImageByMimeType = (mimeType?: string): boolean => {
  if (!mimeType) {
    return false;
  }

  return mimeType.startsWith('image/') && !mimeType.includes('gif');
};
